export const isHealthFeature = (node) => "children" in node;
